import React, { memo } from 'react'
import {
  NOTIFICATION_TOP_RIGHT,
  NOTIFICATION_TYPE_ERROR
} from '../../libraries/Notification'
import { getMergedClassNames } from '../../utils/HTMLutils'
import Notification from '../notification/Notification'
import './BottomNavigation.scss'
const rootClassName = 'bottom-navigation'

interface BottomNavigationProps {
  atual: number
  setAtual: (newAtual: number) => void
  itens: {
    icon: React.ReactElement
    label: string
    notificationCount?: number
  }[]
  theme?: 'dark' | 'white' | 'secondary-lighter' | 'primary'
}

function BottomNavigation(props: BottomNavigationProps) {
  return (
    <div className={getMergedClassNames([rootClassName, props.theme])}>
      {props.itens!?.map((item, index: number) => {
        return (
          <button
            key={index}
            className={getMergedClassNames([
              `${rootClassName}-item`,
              index === props.atual ? 'atual' : ''
            ])}
            onClick={() => {
              if (props.atual !== index) props.setAtual!(index)
            }}
          >
            <div className={`${rootClassName}-icon`}>
              <Notification
                count={item.notificationCount || 0}
                position={NOTIFICATION_TOP_RIGHT}
                type={NOTIFICATION_TYPE_ERROR}
                horizontalOuter={12}
                verticalOuter={6}
              >
                {item.icon}
              </Notification>
            </div>
            <div className={`${rootClassName}-label`}>{item.label}</div>
          </button>
        )
      })}
    </div>
  )
}

BottomNavigation.defaultProps = {
  theme: 'white'
}

export default memo(BottomNavigation)
